function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { assetIsImage, getFiletypeIcon } from '../../helpers/assets';
import useInViewport from '../../helpers/hooks/useInViewport';
var AssetThumbnail = function AssetThumbnail(_ref) {
  var assetID = _ref._id,
    filename = _ref.filename,
    type = _ref.type,
    lowRes = _ref.lowRes,
    contentType = _ref.contentType,
    _onClick = _ref.onClick;
  var ref = useRef();
  var bucket = useSelector(function (s) {
    return s.config.bucket;
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var getFilename = function getFilename() {
    if (lowRes) return lowRes;
    return filename;
  };
  useInViewport({
    ref: ref,
    rootMargin: '100px 0px -100px 0px',
    onChange: function onChange(_ref2) {
      var intersecting = _ref2.intersecting;
      if (intersecting) setVisible(true);
    }
  });
  useEffect(function () {
    if (!visible) return;
    var img = new window.Image();
    img.onload = function () {
      $("#".concat(assetID, "-img")).css({
        opacity: 1
      });
    };
    img.src = "".concat(bucket, "/").concat(getFilename());
  }, [visible]);
  return /*#__PURE__*/React.createElement("div", {
    className: "asset-thumb",
    onClick: function onClick() {
      if (_onClick) _onClick({
        assetID: assetID
      });
    },
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: "asset-thumb__img"
  }, assetIsImage[type] && visible && /*#__PURE__*/React.createElement("img", {
    id: "".concat(assetID, "-img"),
    src: "".concat(bucket, "/").concat(getFilename()),
    className: "asset-thumb__img--lowres"
  }), !assetIsImage[type] && /*#__PURE__*/React.createElement("img", {
    src: getFiletypeIcon(contentType),
    className: "asset-thumb__img--icon"
  })));
};
export default AssetThumbnail;